import { Component, inject, OnInit } from '@angular/core';
import { NavigationEnd, Router, UrlTree } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { ScreenService } from '@app/core';
import { NzI18nService } from 'ng-zorro-antd/i18n';
import { es } from 'date-fns/locale';
import { filter } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
  styleUrl: './app.component.less',
})
export class AppComponent implements OnInit {
  title = 'Sourtrack';
  isDetailRoute: boolean = false;
  isPdfRoute = false;
  isAuthCallbackRoute = false;
  public readonly oidcSecurityService = inject(OidcSecurityService);

  isAuthenticating: boolean = false;

  constructor(
    private router: Router,
    private screenService: ScreenService,
    private i18n: NzI18nService
  ) {
    screenService.isAuthenticating$.subscribe(
      (value) => (this.isAuthenticating = value)
    );
    screenService.fontsLoaded();

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.updateRouteFlags(event.url);
      });

    // Inicializar según la ruta actual
    this.updateRouteFlags(this.router.url);
  }

  ngOnInit(): void {
    if (!window.location.href.includes('auth/callback')) {
      // Guardar pathname + search params para preservar query params después de la autenticación
      const fullPath = window.location.pathname + window.location.search;
      localStorage.setItem('currentPathname', fullPath);
    }

    // Opcional: Suscribirse a cambios de ruta
    this.router.events.subscribe(() => {
      const routeUrl = this.router.url;
      this.isDetailRoute = routeUrl.includes('detail');
    });

    this.configureGlobalDateSettings();
  }

  startLogin(): void {
    this.oidcSecurityService.authorize();
  }

  private configureGlobalDateSettings(): void {
    // Obtener locale según idioma del usuario
    const userLanguage = navigator.language || 'es-ES';
    const locale = this.getDateLocaleConfig(userLanguage);

    // Aplicar configuración global
    this.i18n.setDateLocale(locale);
  }

  private getDateLocaleConfig(language: string): Locale {
    // Determinar locale base según idioma
    const baseLocale = es;

    // Crear configuración personalizada
    return {
      ...baseLocale,
      options: {
        ...baseLocale.options,
        weekStartsOn: 1 as 1, // Lunes como primer día (con tipo literal)
        firstWeekContainsDate: 4, // Opcional: estándar ISO (semana 1 contiene 4 de enero)
      },
    };
  }

  private updateRouteFlags(url: string): void {
    this.isAuthCallbackRoute = url.includes('/auth/callback');
    // Determinar si es ruta PDF
    this.isPdfRoute =
      url.includes('/estado-pago/') || url.includes('/orden-compra/');

    // Tu lógica existente para isDetailRoute
    // this.isDetailRoute = ...
  }
}
